import DuckEntity from './DuckEntity'

const entity = new DuckEntity('checklistItems');
const reducer = entity.reducer;
export {reducer as default, entity};
